<!--
 * @FilePath: /eshop-ops-web/src/views/goodsManage/baseDepot/components/goodsInfo.vue
 * @Description: 
 * @Author: xiexingzhong2012@sina.cn
 * @Date: 2023-07-24 20:01:25
 * @LastEditTime: 2023-07-30 20:22:44
 * @LastEditors: xiexingzhong2012@sina.cn
-->
<template>
  <div class="">
    <el-form
      ref="goods-info"
      label-width="120px"
      :model="formTool"
      :rules="rules"
      size="small"
      :disabled="disabled"
      label-position="right"
    >
      <el-row>
        <el-col :span="24">
          <el-form-item label="商品类型" prop="goodsType">
            <el-radio-group
              v-model="formTool.goodsType"
              @change="changeType(formTool.goodsType)"
            >
              <el-radio
                v-for="item in formTool.typeList"
                :key="item.id"
                :label="item.id"
                >{{ item.name }}</el-radio
              >
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row v-if="pageType != '4'">
        <el-col :span="12">
          <goods-three-class
            ref="three-class"
            :formTool="formTool"
            :isShowLable="true"
            :lableText="'商品分类'"
          ></goods-three-class>
        </el-col>
      </el-row>

      <el-row>
        <el-col :span="12">
          <el-form-item label="产品名称" prop="name">
            <el-input
              v-model.trim="formTool.name"
              placeholder="请输入"
              @blur="checkName"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row>
        <el-col :span="12" v-if="pageType != '4'">
          <el-form-item label="经营范围" prop="businessScopeId">
            <el-select
              v-model="formTool.businessScopeId"
              size="small"
              placeholder="请选择"
              style="width: 100%"
            >
              <el-option
                v-for="item in formTool.scopeList"
                :label="item.name"
                :value="item.id"
                :key="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row>
        <el-col :span="12">
          <el-form-item label="规格" prop="specification">
            <el-input
              v-model.trim="formTool.specification"
              placeholder="请输入"
            />
          </el-form-item>
        </el-col>
      </el-row>

      <el-row>
        <el-col :span="12">
          <el-form-item label="批准文号" prop="approvalNumber">
            <el-input
              v-model.trim="formTool.approvalNumber"
              placeholder="请输入"
            />
          </el-form-item>
        </el-col>
      </el-row>

      <el-row>
        <el-col :span="12">
          <el-form-item label="生产厂家" prop="factory">
            <el-input v-model.trim="formTool.factory" placeholder="请输入" />
          </el-form-item>
        </el-col>
      </el-row>

      <el-row v-if="showProducer">
        <el-col :span="12">
          <el-form-item label="产地" prop="origin">
            <el-input v-model.trim="formTool.origin" placeholder="请输入" />
          </el-form-item>
        </el-col>
      </el-row>

      <el-row>
        <el-col :span="12">
          <el-form-item label="品牌名" prop="brand">
            <el-input v-model.trim="formTool.brand" placeholder="请输入" />
          </el-form-item>
        </el-col>
      </el-row>

      <el-row>
        <el-col :span="12">
          <el-form-item label="单位" prop="unit">
            <el-select
              v-model="formTool.unit"
              placeholder="请选择"
              size="small"
              style="width: 100%"
            >
              <el-option
                v-for="item in unitList"
                :key="item"
                :label="item"
                :value="item"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>

      <!-- 商品分类属性 -->
      <el-row>
        <el-col :span="12">
          <dynamic-attribute
            ref="dynamic-attribute"
            :formTool="formTool"
          ></dynamic-attribute>
        </el-col>
      </el-row>

      <el-row>
        <el-col :span="24">
          <el-form-item label="图片" prop="imageList">
            <imgUpload
              v-model="formTool.imageList"
              :limit="5"
              :isEdit="disabled"
            />
            <div class="upload-tips">
              上传图片大小需低于2M，图片格式PNG,JPG,JPEG，图片尺寸建议800 x
              800px
            </div>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-form-item label="商品详情">
            <wangEnduit
              :value="formTool.detail"
              :is-clear="isClear"
              :isDisabled="disabled"
              @changeEndit="watchEndit"
            />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div class="mt20 bottomBtn">
      <el-button
        type="primary"
        style="width: 160px"
        size="small"
        @click="overwriteSubmit('overwrite')"
        :disabled="disabled"
        v-if="
          pageType == 2 &&
          status != 'PERFECT' &&
          status != 'ALREADY' &&
          status != 'SOLDOUT'
        "
        >提交二审</el-button
      >
      <el-button
        type="primary"
        style="width: 160px"
        size="small"
        @click="overwriteSubmit('second')"
        :disabled="disabled"
        v-if="pageType == 2 && status == 'PERFECT' && permissions.second_check"
        >二审通过</el-button
      >
      <!-- 商品状态为已完善未审核PERFECT，已审核ALREADY，全网下架时SOLDOUT，不需要提交审核 -->
      <el-button
        type="primary"
        style="width: 160px"
        size="small"
        @click="overwriteSubmit('save')"
        :disabled="disabled"
        v-if="pageType == 2 || pageType == 3 || pageType == 5"
        >保存</el-button
      >
      <el-button
        type="primary"
        style="width: 160px"
        size="small"
        @click="goNext"
        v-if="pageType == 4 && status == 'AWAIT'"
        >创建基库商品</el-button
      >
      <el-button
        type="primary"
        style="width: 160px"
        size="small"
        @click="rejectGoods"
        v-if="pageType == 4 && status == 'AWAIT'"
        >驳回</el-button
      >

      <el-button size="small" style="width: 160px" @click="back()"
        >返回</el-button
      >
    </div>
    <!-- /** 
     * @description: //pageType
     * 1 商品基库-》 查看 操作：返回）
     * 2 商品基库-》 编辑（操作：保存提交，返回）
     * 3 商品基库-》 创建 （操作：保存提交，返回）
     * 4 商家申请-》详情 （操作：创建基库，驳回）
     * 5 商家申请-》创建商品基础库 （操作：保存提交，返回）
     * @return {*}
     */ -->
  </div>
</template>
<script>
import imgUpload from "@/components/imgUpload";
import fileUpload from "@/components/fileUpload";
import wangEnduit from "@/components/wangEnduit";
import DynamicAttribute from "@/components/dynamicAttribute";
import GoodsThreeClass from "@/components/goodsThreeClass";
import getComList from "@/utils/getComList";
import {
  getAttributeByTypeId,
  getCompGoodsBaseDetail,
  getGoodsTemporaryDetail,
} from "@/api/goodsManage/baseDepot.js";
import {
  getunitList,
  searchInBlackList,
} from "@/api/productManage/auditProduct";
import { mapGetters } from "vuex";

export default {
  components: {
    imgUpload,
    wangEnduit,
    fileUpload,
    DynamicAttribute,
    GoodsThreeClass, //商品三级分类
  },
  props: {},
  data() {
    return {
      id: null,
      status: null,
      pageType: null,
      disabled: false,
      showProducer: false,
      formTool: {
        origin: "",
        goodsType: null,
        details: null, // 商品详情
        goodsOneClassId: "",
        goodsTwoClassId: "",
        goodsThreeClassId: "",
        typeList: [],
        name: "", // 产品名称
        image: "",
        imageList: [], // 图片
        fileListStr: "",
        fileList: [],
        extendParams: [], //拓展属性
        businessScopeId: null, //经营范围
        specification: null,
        approvalNumber: null,
        factory: null,
        brand: null,
        unit: null,
      },
      unitList: [],
      rules: {
        name: [{ required: true, message: "请输入产名称", trigger: "blur" }],
        goodsType: [
          { required: true, message: "请输入商品类型", trigger: "blur" },
        ],
        businessScopeId: [
          { required: true, message: "请输入经营范围", trigger: "blur" },
        ],
        specification: [
          { required: true, message: "请输入规格", trigger: "blur" },
        ],
        approvalNumber: [
          { required: true, message: "请输入批准文号", trigger: "blur" },
        ],
        factory: [
          { required: true, message: "请输入生产厂家", trigger: "blur" },
        ],
        origin: [{ required: true, message: "请输入产地", trigger: "blur" }],
        unit: [{ required: true, message: "请选择单位", trigger: "change" }],
        goodsOneClassId: [
          { required: true, message: "请输入第一级分类", trigger: "change" },
        ],
        goodsTwoClassId: [
          { required: true, message: "请输入第二级分类", trigger: "change" },
        ],
        goodsThreeClassId: [
          { required: true, message: "请输入第三级分类", trigger: "change" },
        ],
        imageList: [
          { required: true, message: "请上传图片", trigger: "change" },
        ],
      },
      isClear: false, // 清除富文本编辑内容
    };
  },
  computed: {
    ...mapGetters(["permissions"]),
  },
  created() {},
  mounted() {
    this.init();
    this.getunitList();
  },
  beforeCreate() {},
  beforeMount() {},
  beforeUpdate() {},
  updated() {},
  beforeDestroy() {},
  destroyed() {},
  activated() {},
  watch: {
    // 路由发生变化页面刷新
    $route(to, from) {
      // 在created、mounted函数执行的方法，放到该处再执行一次
      this.init();
    },
  },
  methods: {
    checkName() {
      searchInBlackList({
        goodsName: this.formTool.name,
      }).then((res) => {
        if (res) {
          // 此商品在黑名单中，无法新增
          this.$confirm("此商品在黑名单中，无法新增", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          })
            .then(() => {})
            .finally(() => {
              this.formTool.name = "";
            });
        }
      });
    },
    // 获取单位字典
    getunitList() {
      getunitList().then((res) => {
        if (res.code == 0) {
          this.unitList = res.data || [];
        }
      });
    },
    handelSetId(postId) {
      // 手动设置id 当前页面不会返回 需要从返回结果得到id 并且重新设置
      // 不然会重复新增
      if (postId) {
        this.id = postId;
      }
    },
    init() {
      this.pageType = this.$route.query.pageType;
      console.log(this.pageType);
      if (this.pageType == 4 || this.pageType == 1) {
        this.disabled = true;
      }
      if (this.pageType == 5) {
        this.disabled = false;
      }
      if (status != undefined) {
        this.status = this.$route.query.status;
      }
      this.typeList();
    },

    goNext() {
      this.$router.replace(
        "./goodsManage-baseDepot-details?pageType=5&id=" + this.$route.query.id
      );
    },

    async typeList() {
      this.formTool.typeList = await getComList.goodsType; // 商品类型
      this.formTool.scopeList = await getComList.scopeList; //经营范围

      // console.log(this.formTool.typeList, "this.formTool.typeList");
      if (this.formTool.typeList.length > 0 && !this.$route.query.id) {
        this.formTool.goodsType = this.formTool.typeList[0].id;
        this.getAttributeByTypeId(this.formTool.goodsType);
      }
      // 查询详情信息
      if (this.$route.query.id != undefined) {
        this.id = this.$route.query.id;
        this.getDetail(this.$route.query.id);
      } else if (this.formTool.typeList[0].name.indexOf("中药") != -1) {
        this.showProducer = true;
      }
      this.$forceUpdate();
    },

    changeType(typeId) {
      this.getAttributeByTypeId(typeId);
      this.$refs["three-class"].changeType(this.formTool.goodsType); //回显三级分类
      this.isShowProducer(this.formTool.goodsType, this.formTool.typeList);
    },

    back() {
      this.$emit("back");
    },
    /**
     * @functionName: getAttributeByTypeId
     * @description: 根据id 查询商品属性
     * @param id
     * @return {*}
     */
    getAttributeByTypeId(typeId) {
      getAttributeByTypeId({
        typeId: typeId,
        isMerchant: false, //是否根据商户去查，运营端传false 查全部
      }).then((res) => {
        console.log(res);
        if (res.code == 0) {
          let extendParams = res.data;
          for (let i = 0; i < extendParams.length; i++) {
            if (extendParams[i].input == "2") {
              extendParams[i].selectList =
                extendParams[i].selectEnum.split("，"); //中文逗号分隔
            }
            if (extendParams[i].input == "3") {
              extendParams[i].selectList =
                extendParams[i].selectEnum.split(",");
            }
          }
          this.formTool.extendParams = extendParams;
          this.$forceUpdate();
          if (this.$refs["goods-info"]) {
            this.$refs["goods-info"].clearValidate();
          }
        } else {
          this.$message({
            message: res.msg,
            type: "erro",
          });
        }
      });
    },

    /**
     * @description: 初始化加载 配置的 list： 1. 商品类型 2. 经营范围
     * @return {*}
     */
    formatterStr() {
      if (
        this.formTool.fileListStr &&
        this.formTool.fileListStr.indexOf("http") != -1
      ) {
        this.formTool.fileList = this.strTofileList(this.formTool.fileListStr);
      }
      if (
        this.formTool.imageList &&
        this.formTool.imageList.indexOf("http") != -1
      ) {
        this.formTool.imageList = this.strToArr(this.formTool.imageList);
        console.log(this.formTool.imageList);
      } else {
        this.formTool.imageList = [];
      }
    },
    // 判断当前商品类型是否是中药饮片，是的话显示产地必填
    isShowProducer(goodsType, goodsTypeList) {
      let show = false;
      for (let i = 0; i < goodsTypeList.length; i++) {
        if (
          goodsType == goodsTypeList[i].id &&
          goodsTypeList[i].name.indexOf("中药") != -1
        ) {
          console.log(goodsTypeList[i].name, "------------name");
          show = true;
        }
      }
      this.showProducer = show;
    },
    getDetail(id) {
      /**
       * @description:   // 1.获取基础库详情/ 获取商品详情信息，2.映射到formTool 对象 。
       * @return {*} formTool
       */

      if (this.pageType == "5" || this.pageType == "4") {
        this.getGoodsTemporaryDetail(id);
      } else {
        this.getCompGoodsBaseDetail(id);
      }
    },

    //  获取基础库详情
    getCompGoodsBaseDetail(id) {
      const params = {
        id: id,
      };
      getCompGoodsBaseDetail(params).then((res) => {
        if (res.code === 0) {
          console.log(res);
          //  console.log('-----------------')
          let compGoodsBaseVo = res.data.compGoodsBaseVo;
          this.formTool = Object.assign(this.formTool, compGoodsBaseVo); //合并2个对象
          let extendParams = res.data.extendParams;
          if (extendParams) {
            for (let i = 0; i < extendParams.length; i++) {
              if (extendParams[i].input == "3") {
                this.formTool.fileList = this.strTofileList(
                  extendParams[i].value
                );
              }
              if (extendParams[i].input == "2") {
                extendParams[i].selectList =
                  extendParams[i].selectEnum.split("，");
              }
            }
          }
          this.$nextTick(() => {
            this.$set(this.formTool, "extendParams", extendParams);
          });

          this.$forceUpdate();
          this.$refs["three-class"].queryDetail(this.formTool.goodsType); //回显三级分类
          this.formatterStr(); //数据类型转换
          this.isShowProducer(this.formTool.goodsType, this.formTool.typeList);
        }
      });
    },

    //  获取商品详情
    getGoodsTemporaryDetail(id) {
      const params = {
        id: id,
        isMerchant: false, //false 查所有拓展属性
      };
      getGoodsTemporaryDetail(params).then((res) => {
        if (res.code === 0) {
          console.log(res);
          let compGoodsTemporaryEntity = res.data.compGoodsTemporaryEntity;

          // 商家三级分类未有值时不合并 以免重新赋值触发校验from
          if (!compGoodsTemporaryEntity.goodsOneClassId) {
            delete compGoodsTemporaryEntity.goodsOneClassId;
          }
          if (!compGoodsTemporaryEntity.goodsTwoClassId) {
            delete compGoodsTemporaryEntity.goodsTwoClassId;
          }
          if (!compGoodsTemporaryEntity.goodsThreeClassId) {
            delete compGoodsTemporaryEntity.goodsThreeClassId;
          }
          // 商家经营范围未有值时不合并 以免重新赋值触发校验from
          if (!compGoodsTemporaryEntity.businessScopeId) {
            delete compGoodsTemporaryEntity.businessScopeId;
          }

          this.formTool = Object.assign(
            this.formTool,
            compGoodsTemporaryEntity
          ); //合并2个对象
          // this.formTool.imageList = res.data.compGoodsTemporaryEntity.imageList;
          let extendParams = res.data.extendParams;
          if (extendParams) {
            for (let i = 0; i < extendParams.length; i++) {
              if (extendParams[i].input == "3") {
                this.formTool.fileList = this.strTofileList(
                  extendParams[i].value
                );
              }
              if (extendParams[i].input == "2") {
                extendParams[i].selectList =
                  extendParams[i].selectEnum.split("，");
              }
            }
          }
          this.$nextTick(() => {
            this.$set(this.formTool, "extendParams", extendParams);
          });

          this.$forceUpdate();
          this.$nextTick(() => {
            if (this.$refs["three-class"]) {
              this.$refs["three-class"].query(this.formTool.goodsType);
            }
          });
          // this.$refs["three-class"].queryDetail(); //回显三级分类
          this.formatterStr(); //数据类型转换
          this.isShowProducer(this.formTool.goodsType, this.formTool.typeList);
        }
      });
    },

    /**
     * @functionName: onRemoveHandler
     * @description: 删除上传的文件
     * @return {*}
     */
    onRemoveHandler(file) {
      let index = this.formTool.fileList.indexOf(file);
      this.formTool.fileList.splice(index, 1);
    },
    // 二审
    secondSubmit() {},
    /**
     * @description: submit 方法 提交form 数据给业务调用方
     * @return {*} fromlToll
     */
    overwriteSubmit(type = "save") {
      const params = Object.assign({}, this.formTool);
      let fileListStr = "";

      for (let j = 0; j < this.formTool.fileList.length; j++) {
        fileListStr += this.formTool.fileList[j].url + ",";
      }

      this.formTool.fileListStr = fileListStr;
      for (let i = 0; i < this.formTool.extendParams.length; i++) {
        if (
          this.formTool.fileList.length > 0 &&
          this.formTool.extendParams[i].input == "3"
        ) {
          this.formTool.extendParams[i].value = this.formTool.fileListStr;
        }

        if (
          this.formTool.extendParams[i].required &&
          !this.formTool.extendParams[i].value
        ) {
          this.$message({
            message: this.formTool.extendParams[i].name + "请填写完整信息！",
            type: "warning",
          });
          return false;
        }
      }

      let extendParamsList = [...this.formTool.extendParams];
      let extendParamsObj = {};
      for (let i = 0; i < extendParamsList.length; i++) {
        extendParamsObj[extendParamsList[i].fieldName] =
          extendParamsList[i].value;
      }
      params.extendParams = extendParamsObj;
      params.image = params.imageList[0];
      params.imageList = params.imageList.join();
      // console.log(params);
      const {
        name,
        goodsOneClassId,
        goodsTwoClassId,
        goodsThreeClassId,
        imageList,
        goodsType,
        extendParams,
        businessScopeId,
        specification,
        approvalNumber,
        factory,
        detail,
        image,
        origin,
        brand,
        unit,
      } = params;
      let paramsData = {
        name,
        goodsOneClassId,
        goodsTwoClassId,
        goodsThreeClassId,
        imageList,
        goodsType,
        extendParams,
        businessScopeId,
        specification,
        approvalNumber,
        factory,
        detail,
        image,
        origin,
        brand,
        unit,
      };
      if (this.id != undefined) {
        paramsData.id = this.id;
      }
      if (this.pageType == 5) {
        paramsData.temporaryId = this.id;
        paramsData.whetherCheck = true;
      }
      this.$refs["goods-info"].validate((valid) => {
        if (!valid) {
          this.$message({
            message: "请填写完整信息！",
            type: "warning",
          });
        } else {
          if ("save" == type) {
            this.$emit("submit-goods", paramsData);
          } else if ("overwrite" == type) {
            this.$emit("overwritesubmit-goods", paramsData);
          } else if ("second" == type) {
            this.$emit("secondsubmit-goods", paramsData);
          }
        }
      });
    },

    // 驳回
    rejectGoods() {
      const h = this.$createElement;
      this.$prompt(h("p", null, [h("p", null)]), "驳回原因", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      })
        .then(({ value }) => {
          if (value != "" && value != undefined) {
            value = value.trim();
          }
          if (value == "" || value == undefined) {
            this.$message({
              message: "请填写驳回原因！",
              type: "error",
            });
            return;
          }
          let params = {
            goodsId: this.formTool.id,
            status: "FAIL",
            rejectReason: value,
          };
          this.$emit("reject-goods", params);
        })
        .catch((err) => {
          console.log(err);
          this.$message({
            type: "info",
            message: "取消输入",
          });
        });
    },

    watchEndit(val) {
      // 监听富文本编辑传过来的数据
      this.formTool.detail = val;
    },

    // 上传图片的字符串转 list
    strToArr(str) {
      let list = [];
      let newStr = str;
      if (newStr.indexOf(",") != -1) {
        let arr = newStr.split(",");
        arr.map((item) => {
          if (item.indexOf("http") != -1) {
            list.push(item);
          }
        });
      } else if (newStr.indexOf("http") != -1) {
        list.push(newStr);
      }
      return list;
    },

    // 上传文件的字符串转 fileList
    strTofileList(fileListStr) {
      console.log(fileListStr);
      let fileList = [];
      let newStr = fileListStr;
      if (newStr && newStr.indexOf(",") != -1) {
        let arr = newStr.split(",");
        arr.map((item) => {
          if (item.indexOf("http") != -1) {
            fileList.push({
              name:
                item.indexOf(item) != -1
                  ? item.substring(item.lastIndexOf("/") + 1)
                  : item,
              url: item,
            });
          }
        });
      } else if (newStr && newStr.indexOf("http") != -1) {
        fileList.push({
          name: newStr.substring(newStr.lastIndexOf("/") + 1),
          url: newStr,
        });
      }
      return fileList;
    },
  },
};
</script>
<style lang="scss" scoped>
.comContent {
  padding: 0px;
}

.addGoods {
  width: 100%;
  height: 40px;
  border: 1px dashed #d9d9d9;
  border-radius: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  margin-top: 10px;

  .addFont {
    // border: 1px dashed #d9d9d9;
    display: flex;
    width: 18px;
    font-size: 16px;
    justify-content: center;
    margin-right: 5px;
  }
}

.header {
  height: 56px;
  line-height: 56px;
  padding: 0 24px;
  border-bottom: 1px solid #f5f5f5;
}

.product {
  // margin: 0 24px;
  margin-bottom: 24px;
}

.firstTitle {
  font-size: 16px;
  color: #262626;
  font-weight: 700;
}

.secondTitle {
  font-size: 14px;
  // color: #999999;
}

.upload-tips {
  font-size: 12px;
  color: #8c8c8c;
}

.bottomBtn {
  // position: fixed;
  // bottom: 50px;
  padding-left: 120px;
}
</style>
